export const flattenObjLists = <V = unknown>(obj: { [key: string]: V[] }): V[] => {
    return Object.values(obj).reduce((current, next) => {
        return [...current, ...next];
    }, []);
};
